import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RichTextBlockComponent } from './rich-text-block.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  declarations: [
    RichTextBlockComponent
  ],
  exports: [
    RichTextBlockComponent
  ]
})
export class RichTextBlockModule { }
